/**
 * 交流合作专区 案例分享 API
 */

import request from '@/utils/request'

export default {
  get: (data) => {
    return request.get(`/api/frLegalPlatform/web/hot/article/page`, { params: data })
  },
  getDetail: (id, data) => {
    return request.get(`/api/frLegalPlatform/web/hot/article/${id}`, { params: data })
  }
}
